// extracted by mini-css-extract-plugin
export default {"ljiRed":"#ee2346","errorText":"CustomErrorMessage_errorText__j-HSy"};